import "./assets/css/style.css"
import AppRouter from "./components/AppRouter";


function App() {
  return (
    <>
      <AppRouter />
    </>
  );
}

export default App;
